import React, { useContext } from 'react';
import { XingFrameContext } from '@xingternal/xing-frame-provider';

import XingView from '@xingternal/xing-view';

import styles from './LoggedInApp.css';

type LoggedInAppProps = {
  children: React.ReactNode;
};

const LoggedInApp = ({ children }: LoggedInAppProps) => {
  const { featureSwitches } = useContext(XingFrameContext);

  const isArmstrong =
    featureSwitches?.filter((x) => x === 'armstrong_v1').length > 0;

  return (
    <XingView withSubNav={isArmstrong} gridClassName={styles.gridClassName}>
      {children}
    </XingView>
  );
};

export default LoggedInApp;
